export const PATIENT_LAST_REPORT_OPTIONS = {
  APPOINTMENT_DATE_TIME: "Patient.LastReport.AppointmentDateTime",
  APPOINTMENT_TYPE: "Patient.LastReport.AppointmentType",
  LEFT_HEARING_LOSS: "Patient.LastReport.LeftHearingLoss",
  RIGHT_HEARING_LOSS: "Patient.LastReport.RightHearingLoss",
  LEFT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.LastReport.LeftWRSAndPresentationLevel",
  RIGHT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.LastReport.RightWRSAndPresentationLevel",
  LEFT_QUICKSIN_AND_SNR_LOSS: "Patient.LastReport.LeftQuickSinAndSnrLoss",
  RIGHT_QUICKSIN_AND_SNR_LOSS: "Patient.LastReport.RightQuickSinAndSnrLoss",
  BINAURAL_QUICKSIN_AND_SNR_LOSS:
    "Patient.LastReport.BinauralQuickSinAndSnrLoss",
  LEFT_TYMPANOGRAM_TYPE: "Patient.LastReport.LeftTympanogramType",
  RIGHT_TYMPANOGRAM_TYPE: "Patient.LastReport.RightTympanogramType",
  LEFT_HEARING_LOSS_LEVEL: "Patient.LastReport.LeftHearingLossLevel",
  RIGHT_HEARING_LOSS_LEVEL: "Patient.LastReport.RightHearingLossLevel",
  LEFT_HEARING_LOSS_SHAPE: "Patient.LastReport.LeftHearingLossShape",
  RIGHT_HEARING_LOSS_SHAPE: "Patient.LastReport.RightHearingLossShape",
  LEFT_HEARING_LOSS_TYPE: "Patient.LastReport.LeftHearingLossType",
  RIGHT_HEARING_LOSS_TYPE: "Patient.LastReport.RightHearingLossType",
  LEFT_AIR_CONDUCTION_THRESHOLDS:
    "Patient.LastReport.LeftAirConductionThresholds",
  RIGHT_AIR_CONDUCTION_THRESHOLDS:
    "Patient.LastReport.RightAirConductionThresholds",
  LEFT_BONE_CONDUCTION_THRESHOLDS:
    "Patient.LastReport.LeftBoneConductionThresholds",
  RIGHT_BONE_CONDUCTION_THRESHOLDS:
    "Patient.LastReport.RightBoneConductionThresholds",
  LEFT_PTA: "Patient.LastReport.LeftPta",
  RIGHT_PTA: "Patient.LastReport.RightPta",
  LEFT_SRT: "Patient.LastReport.LeftSrt",
  RIGHT_SRT: "Patient.LastReport.RightSrt",
  LEFT_SRT_MASKING: "Patient.LastReport.LeftSrtMasking",
  RIGHT_SRT_MASKING: "Patient.LastReport.RightSrtMasking",
  LEFT_WRS_MASKING: "Patient.LastReport.LeftWrsMasking",
  RIGHT_WRS_MASKING: "Patient.LastReport.RightWrsMasking",
  LEFT_TYMPANOMETRY_ADMITTANCE: "Patient.LastReport.LeftTympanometryAdmittance",
  RIGHT_TYMPANOMETRY_ADMITTANCE:
    "Patient.LastReport.RightTympanometryAdmittance",
  LEFT_TYMPANOMETRY_ECV: "Patient.LastReport.LeftTympanometryEcv",
  RIGHT_TYMPANOMETRY_ECV: "Patient.LastReport.RightTympanometryEcv",
  LEFT_TYMPANOMETRY_PRESSURE: "Patient.LastReport.LeftTympanometryPressure",
  RIGHT_TYMPANOMETRY_PRESSURE: "Patient.LastReport.RightTympanometryPressure",
  LEFT_ACOUSTIC_REFLEX_THRESHOLDS:
    "Patient.LastReport.LeftAcousticReflexThresholds",
  RIGHT_ACOUSTIC_REFLEX_THRESHOLDS:
    "Patient.LastReport.RightAcousticReflexThresholds",
  LEFT_ACOUSTIC_REFLEX_DECAY: "Patient.LastReport.LeftAcousticReflexDecay",
  RIGHT_ACOUSTIC_REFLEX_DECAY: "Patient.LastReport.RightAcousticReflexDecay",
  LEFT_QUICKSIN_METHOD: "Patient.LastReport.LeftQuickSinMethod",
  RIGHT_QUICKSIN_METHOD: "Patient.LastReport.RightQuickSinMethod",
  LEFT_OAE_TYPE: "Patient.LastReport.LeftOaeType",
  RIGHT_OAE_TYPE: "Patient.LastReport.RightOaeType",
  LEFT_OAE_RESULTS: "Patient.LastReport.LeftOaeResults",
  RIGHT_OAE_RESULTS: "Patient.LastReport.RightOaeResults",
  ICD10_CODES: "Patient.LastReport.Icd10Codes",
  CUSTOM_TESTS: "Patient.LastReport.CustomTests",
  FULL_AUDIOGRAM: "Patient.LastReport.FullAudiogram",
  SUMMARY: "Patient.LastReport.Summary",
  PROVIDER_NAME: "Patient.LastReport.ProviderName",
  PROVIDER_NAME_WITH_LICENSE: "Patient.LastReport.ProviderNameWithLicense",
  PROVIDER_LICENSE_NUMBER: "Patient.LastReport.ProviderLicenseNumber"
};

const leftEarMenu = [
  {
    title: "Patient - Last Signed Report - Left Hearing Loss",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS
  },
  {
    title: "Patient - Last Signed Report - Left WRS and Presentation Level",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_WRS_PRESENTATION_LEVEL_LOSS
  },
  {
    title: "Patient - Last Signed Report - Left QuickSIN and SNR Loss",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_QUICKSIN_AND_SNR_LOSS
  },
  {
    title: "Patient - Last Signed Report - Left Tympanogram Type",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_TYMPANOGRAM_TYPE
  },
  {
    title: "Patient - Last Signed Report - Left Hearing Loss Level",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS_LEVEL
  },
  {
    title: "Patient - Last Signed Report - Left Hearing Loss Shape",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS_SHAPE
  },
  {
    title: "Patient - Last Signed Report - Left Hearing Loss Type",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS_TYPE
  },
  {
    title: "Patient - Last Signed Report - Left Air Conduction Thresholds",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_AIR_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Last Signed Report - Left Bone Conduction Thresholds",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_BONE_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Last Signed Report - Left PTA",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_PTA
  },
  {
    title: "Patient - Last Signed Report - Left SRT",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_SRT
  },
  {
    title: "Patient - Last Signed Report - Left SRT Masking",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_SRT_MASKING
  },
  {
    title: "Patient - Last Signed Report - Left WRS Masking",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_WRS_MASKING
  },
  {
    title: "Patient - Last Signed Report - Left Tympanometry Admittance",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_TYMPANOMETRY_ADMITTANCE
  },
  {
    title: "Patient - Last Signed Report - Left Tympanometry ECV",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_TYMPANOMETRY_ECV
  },
  {
    title: "Patient - Last Signed Report - Left Tympanometry Pressure",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_TYMPANOMETRY_PRESSURE
  },
  {
    title: "Patient - Last Signed Report - Left Acoustic Reflex Thresholds",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_ACOUSTIC_REFLEX_THRESHOLDS
  },
  {
    title: "Patient - Last Signed Report - Left Acoustic Reflex Decay",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_ACOUSTIC_REFLEX_DECAY
  },
  {
    title: "Patient - Last Signed Report - Left QuickSIN Method",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_QUICKSIN_METHOD
  },
  {
    title: "Patient - Last Signed Report - Left OAE Type",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_OAE_TYPE
  },
  {
    title: "Patient - Last Signed Report - Left OAE Results",
    value: PATIENT_LAST_REPORT_OPTIONS.LEFT_OAE_RESULTS
  }
];

const rightEarMenu = [
  {
    title: "Patient - Last Signed Report - Right Hearing Loss",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS
  },
  {
    title: "Patient - Last Signed Report - Right WRS and Presentation Level",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_WRS_PRESENTATION_LEVEL_LOSS
  },
  {
    title: "Patient - Last Signed Report - Right QuickSIN and SNR Loss",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_QUICKSIN_AND_SNR_LOSS
  },
  {
    title: "Patient - Last Signed Report - Right Tympanogram Type",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_TYMPANOGRAM_TYPE
  },
  {
    title: "Patient - Last Signed Report - Right Hearing Loss Level",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS_LEVEL
  },
  {
    title: "Patient - Last Signed Report - Right Hearing Loss Shape",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS_SHAPE
  },
  {
    title: "Patient - Last Signed Report - Right Hearing Loss Type",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS_TYPE
  },
  {
    title: "Patient - Last Signed Report - Right Air Conduction Thresholds",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_AIR_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Last Signed Report - Right Bone Conduction Thresholds",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_BONE_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Last Signed Report - Right PTA",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_PTA
  },
  {
    title: "Patient - Last Signed Report - Right SRT",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_SRT
  },
  {
    title: "Patient - Last Signed Report - Right SRT Masking",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_SRT_MASKING
  },
  {
    title: "Patient - Last Signed Report - Right WRS Masking",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_WRS_MASKING
  },
  {
    title: "Patient - Last Signed Report - Right Tympanometry Admittance",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_TYMPANOMETRY_ADMITTANCE
  },
  {
    title: "Patient - Last Signed Report - Right Tympanometry ECV",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_TYMPANOMETRY_ECV
  },
  {
    title: "Patient - Last Signed Report - Right Tympanometry Pressure",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_TYMPANOMETRY_PRESSURE
  },
  {
    title: "Patient - Last Signed Report - Right Acoustic Reflex Thresholds",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_ACOUSTIC_REFLEX_THRESHOLDS
  },
  {
    title: "Patient - Last Signed Report - Right Acoustic Reflex Decay",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_ACOUSTIC_REFLEX_DECAY
  },
  {
    title: "Patient - Last Signed Report - Right QuickSIN Method",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_QUICKSIN_METHOD
  },
  {
    title: "Patient - Last Signed Report - Right OAE Type",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_OAE_TYPE
  },
  {
    title: "Patient - Last Signed Report - Right OAE Results",
    value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_OAE_RESULTS
  }
];

export const PATIENT_LAST_SIGNED_REPORT_MENU_OPTIONS = {
  title: "Patient - Last Signed Report",
  menu: [
    {
      title: "Patient - Last Signed Report - Appointment Date Time",
      value: PATIENT_LAST_REPORT_OPTIONS.APPOINTMENT_DATE_TIME
    },
    {
      title: "Patient - Last Signed Report - Appointment Type",
      value: PATIENT_LAST_REPORT_OPTIONS.APPOINTMENT_TYPE
    },
    {
      title: "Patient - Last Signed Report - Provider Name",
      value: PATIENT_LAST_REPORT_OPTIONS.PROVIDER_NAME
    },
    {
      title: "Patient - Last Signed Report - Provider Name & License",
      value: PATIENT_LAST_REPORT_OPTIONS.PROVIDER_NAME_WITH_LICENSE
    },
    {
      title: "Patient - Last Signed Report - Provider License Number",
      value: PATIENT_LAST_REPORT_OPTIONS.PROVIDER_LICENSE_NUMBER
    },
    {
      title: "Patient - Last Signed Report - Left Ear",
      menu: leftEarMenu
    },
    {
      title: "Patient - Last Signed Report - Right Ear",
      menu: rightEarMenu
    },
    {
      title: "Patient - Last Signed Report - Binaural QuickSIN and SNR Loss",
      value: PATIENT_LAST_REPORT_OPTIONS.BINAURAL_QUICKSIN_AND_SNR_LOSS
    },
    {
      title: "Patient - Last Signed Report - ICD-10 Codes",
      value: PATIENT_LAST_REPORT_OPTIONS.ICD10_CODES
    },
    {
      title: "Patient - Last Signed Report - Custom Tests",
      value: PATIENT_LAST_REPORT_OPTIONS.CUSTOM_TESTS
    },
    {
      title: "Patient - Last Signed Report - Full Audiogram",
      value: PATIENT_LAST_REPORT_OPTIONS.FULL_AUDIOGRAM
    },
    {
      title: "Patient - Last Signed Report - Summary",
      value: PATIENT_LAST_REPORT_OPTIONS.SUMMARY
    }
  ]
};
